import { PartiallyTranslatable } from "../../../types/translations/Translatable";
import { LanguageCode } from "../../../types/translations/LanguageCode";

export const quads: PartiallyTranslatable = {
    [LanguageCode.en]: "Quads",
    [LanguageCode.ru]: "Квадраты",
};
